export default {
	"name": "ContentSquare",
	"stage": "produktion",
	"mandanten": ["2"],
	"pagetypes": "all",
	"samplingCookie": {
		"name": "ab_bucket",
		"maxValue": 5
	},
	"serviceSettings": {
		"scriptUrl": "//t.contentsquare.net/uxa/469f7f148f08f.js"
	}
}
